import { Component, AfterViewInit } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('app-footer .anim').forEach(el => observer.observe(el));
  }

  scrollTo(id: string, event: Event): void {
    event.preventDefault();
    const el = document.querySelector(id) as HTMLElement;
    if (el) window.scroll({ top: el.offsetTop - 20, behavior: 'smooth' });
  }

  scrollToTop(event: Event): void {
    event.preventDefault();
    window.scroll({ top: 0, behavior: 'smooth' });
  }
}
